export default function HeroSection() {
  return (
    <section className="relative bg-background-50 min-h-screen flex flex-col">
      <div className="w-full px-8 md:px-16 pt-8 md:pt-10 pb-0">
        <div className="flex items-center justify-between">
          <h1 className="text-sm md:text-base font-bold text-foreground-950 tracking-wider font-label">
            VABR SOLUTIONS SRL
          </h1>
        </div>
      </div>

      <div className="flex-1 flex flex-col lg:flex-row w-full px-8 md:px-16 pt-12 md:pt-20 pb-0">
        <div className="w-full lg:w-1/2 flex flex-col justify-start">
          <h2 className="text-6xl md:text-7xl lg:text-8xl font-heading text-foreground-950 leading-[1.05] tracking-tight">
            Modern Engineering
            <br />
            for the iOS Platform
          </h2>
        </div>

        <div className="w-full lg:w-1/2 flex flex-col justify-start lg:pt-4 mt-8 lg:mt-0">
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-md lg:max-w-lg">
            A professional engineering team dedicated to designing and developing modern digital software solutions for the iOS platform and related technologies. We build scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality.
          </p>
          <span className="text-foreground-400 text-lg mt-6 inline-block">&rarr;</span>
        </div>
      </div>

      <div className="w-full px-8 md:px-16 mt-12 md:mt-16 pb-8 md:pb-12">
        <div className="w-full h-[320px] md:h-[400px] rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20macro%20scale%20circuitry%20patterns%20and%20architectural%20concrete%20texture%2C%20minimalist%20technical%20aesthetic%2C%20warm%20charcoal%20and%20silver%20tones%2C%20geometric%20grid%20lines%2C%20soft%20diffused%20lighting%2C%20clean%20composition%2C%20no%20text%2C%20no%20human%20figures%2C%20industrial%20elegance%2C%20high%20detail%20texture%20photography&width=1600&height=400&seq=hero-tech-texture-01&orientation=landscape"
            alt="Abstract technical texture with geometric grid patterns"
            className="w-full h-full object-cover object-center"
          />
        </div>
      </div>
    </section>
  );
}